/**
 * ציור בשפכטל (סכין פלטה) — מריחות שטוחות, קצה חד, צבירה בצד אחד והברקה בקצה השני.
 */

function hexToRgb(hex) {
  const n = String(hex || '').replace('#', '')
  if (n.length !== 6) return [100, 100, 100]
  return [parseInt(n.slice(0, 2), 16), parseInt(n.slice(2, 4), 16), parseInt(n.slice(4, 6), 16)]
}

function rgbToHex(r, g, b) {
  const c = (x) => Math.round(Math.max(0, Math.min(255, x))).toString(16).padStart(2, '0')
  return `#${c(r)}${c(g)}${c(b)}`
}

function mixRgb(a, b, t) {
  return [
    a[0] + (b[0] - a[0]) * t,
    a[1] + (b[1] - a[1]) * t,
    a[2] + (b[2] - a[2]) * t,
  ]
}

function hash2(x, y) {
  const s = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453
  return s - Math.floor(s)
}

/**
 * להב שפכטל — טרפז שטוח (עובי צבע בצד אחד).
 */
function drawKnifeBlade(ctx, length, width, bodyHex, edgeHex, hiHex, cfg) {
  const taper = cfg.taper
  const hw = width / 2
  const hl = length / 2

  ctx.beginPath()
  ctx.moveTo(-hl, -hw)
  ctx.lineTo(hl, -hw * taper)
  ctx.lineTo(hl, hw * taper)
  ctx.lineTo(-hl, hw)
  ctx.closePath()

  ctx.fillStyle = edgeHex
  ctx.globalAlpha = cfg.alphaEdge
  ctx.fill()

  ctx.fillStyle = bodyHex
  ctx.globalAlpha = cfg.alphaBody
  ctx.fill()

  // פס הברקה לאורך הקצה הקדמי
  ctx.beginPath()
  ctx.moveTo(-hl * 0.92, -hw * taper * 0.85)
  ctx.lineTo(hl * 0.95, -hw * taper * 0.55)
  ctx.lineTo(hl * 0.95, -hw * taper * 0.15)
  ctx.lineTo(-hl * 0.88, -hw * 0.35)
  ctx.closePath()
  ctx.fillStyle = hiHex
  ctx.globalAlpha = cfg.alphaHighlight
  ctx.fill()
}

function strokePoints(prev, x, y, step) {
  const dx = x - prev.x
  const dy = y - prev.y
  const dist = Math.hypot(dx, dy)
  if (dist < 0.5) return [{ x, y, t: 1 }]
  const n = Math.max(1, Math.ceil(dist / step))
  const pts = []
  for (let i = 0; i <= n; i++) {
    const t = i / n
    pts.push({ x: prev.x + dx * t, y: prev.y + dy * t, t })
  }
  return pts
}

/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} x
 * @param {number} y
 * @param {{ x: number, y: number } | null} prev
 * @param {{ color: string, brushSize: number, intensity?: number }} opts
 */
export function drawSpachtelStroke(ctx, x, y, prev, opts) {
  const { color, brushSize, intensity = 1 } = opts
  const t = Math.max(0.5, Math.min(1.2, intensity))
  const baseRgb = hexToRgb(color)
  const edgeRgb = mixRgb(baseRgb, [0, 0, 0], 0.32)
  const hiRgb = mixRgb(baseRgb, [255, 255, 255], 0.48)
  const bodyHex = rgbToHex(...baseRgb)
  const edgeHex = rgbToHex(...edgeRgb)
  const hiHex = rgbToHex(...hiRgb)

  const cfg = {
    taper: 0.55 + hash2(x, y) * 0.12,
    alphaBody: 0.88,
    alphaEdge: 0.45,
    alphaHighlight: 0.55,
    stepFactor: 0.42,
    lengthMul: 2.4 * t,
    widthMul: 0.38 * t,
    wobble: 0.08,
  }

  const bladeLen = Math.max(8, brushSize * cfg.lengthMul)
  const bladeW = Math.max(3, brushSize * cfg.widthMul)

  const paintBladeAt = (px, py, angle) => {
    ctx.save()
    ctx.translate(px, py)
    ctx.rotate(angle)
    ctx.globalCompositeOperation = 'source-over'
    drawKnifeBlade(ctx, bladeLen, bladeW, bodyHex, edgeHex, hiHex, cfg)
    ctx.restore()
  }

  if (!prev) {
    const angle = hash2(x, y) * Math.PI * 2
    paintBladeAt(x, y, angle)
    // שארית צבע בקצוות (מריחה קצרה)
    paintBladeAt(x + Math.cos(angle + 0.4) * bladeLen * 0.35, y + Math.sin(angle + 0.4) * bladeLen * 0.35, angle + 0.15)
    return
  }

  const angle = Math.atan2(y - prev.y, x - prev.x)
  const step = Math.max(3, brushSize * cfg.stepFactor)
  const points = strokePoints(prev, x, y, step)

  for (const pt of points) {
    const h = hash2(pt.x * 0.2, pt.y * 0.13)
    const wobble = brushSize * cfg.wobble * (h - 0.5)
    const perp = angle + Math.PI / 2
    const px = pt.x + Math.cos(perp) * wobble
    const py = pt.y + Math.sin(perp) * wobble
    const twist = (hash2(pt.y, pt.x) - 0.5) * 0.12
    paintBladeAt(px, py, angle + twist)

    // פס דק — שריטת מתכת / שכבה דקה
    if (h > 0.62) {
      ctx.save()
      ctx.translate(px, py)
      ctx.rotate(angle + twist)
      ctx.strokeStyle = hiHex
      ctx.globalAlpha = 0.22
      ctx.lineWidth = Math.max(1, bladeW * 0.15)
      ctx.lineCap = 'butt'
      ctx.beginPath()
      ctx.moveTo(-bladeLen * 0.45, -bladeW * 0.35)
      ctx.lineTo(bladeLen * 0.48, -bladeW * 0.22)
      ctx.stroke()
      ctx.restore()
    }
  }
}
